import type { AuthConfig } from "@superblocksteam/shared";

export const SB_OAUTH_CALLBACK_READY = "sb-oauth-callback-ready" as const;
export const SB_OAUTH_CALLBACK_TOKEN = `sb-oauth-callback-${"token"}` as const;

type MessageWindow = Pick<Window, "postMessage">;
type MessageTarget = Pick<Window, "addEventListener" | "removeEventListener">;

export function startOAuthAuthConfigHandoff({
  authConfig,
  oneTimeCode,
  popup,
  targetOrigin,
  windowTarget = window,
}: {
  authConfig: AuthConfig;
  oneTimeCode: string;
  popup: MessageWindow;
  targetOrigin: string;
  windowTarget?: MessageTarget;
}): () => void {
  const onMessage = (event: MessageEvent) => {
    if (
      event.origin !== targetOrigin ||
      event.source !== popup ||
      !event.data ||
      typeof event.data !== "object" ||
      event.data.type !== SB_OAUTH_CALLBACK_READY ||
      event.data.oneTimeCode !== oneTimeCode
    ) {
      return;
    }

    popup.postMessage(
      {
        authConfig,
        oneTimeCode,
        type: SB_OAUTH_CALLBACK_TOKEN,
      },
      targetOrigin,
    );
  };
  windowTarget.addEventListener("message", onMessage as EventListener);

  return () =>
    windowTarget.removeEventListener("message", onMessage as EventListener);
}
